import React, {useState} from "react";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";
import {getCurrentUserMindfiles, getMindfile} from "../../../state/actions/getDataActions";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton,} from "@material-ui/core";
import {API_ROOT} from "../../../baseUrls";
import CloseIcon from "@mui/icons-material/Close";

function ContributorCard({ user, mindfile, contributor, authenticity_token, getMindfile, getCurrentUserMindfiles, isOwner }) {
  const [openDialog, setOpenDialog] = useState(false);
  const [name, setName] = useState("");
  const [removeId, setRemoveId] = useState(null);
  const history = useHistory();

  const reloadAction = isOwner ? () => {} : () => getCurrentUserMindfiles(user.mid);
  const afterRemove = isOwner ? () => getMindfile(mindfile.id) : () => getMindfile(user.mid, () => history.push("/"));

  const handleRemove = () => {
    if (removeId) {
      const formData = new FormData();
      formData.append("remove_id", removeId);
      fetch(`${API_ROOT}/mindfiles/${mindfile.id}/contributors`, {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {'X-CSRF-Token': authenticity_token},
      })
        .then(rest => rest.text())
        .then(reloadAction)
        .then(afterRemove)
        .finally(() => setOpenDialog(false));
    } else {
      setOpenDialog(false);
    }
  };

  const userType = mindfile.owner === contributor.id ? "owner" : "contributor";
  const labelSelf = (contributor.id === user.uid) ? " (you)" : "";
  return (
    <Box>
      <Box
        display="inline-block"
        mr={2}
      >{`${contributor.name} (${userType})${labelSelf}`}</Box>
      {(isOwner && contributor.id !== user.uid) || (!isOwner && contributor.id === user.uid) ? (
        <Box display="inline-block">
          <Button
            variant="contained"
            color="default"
            size="small"
            onClick={() => {
              setOpenDialog(true);
              setName(contributor.name);
              setRemoveId(contributor.id);
            }}
          >
            Remove
          </Button>
        </Box>
      ) : null}

      <Dialog
        PaperProps={{id:"confirmRemoveContributor"}}
        onClose={() => {setOpenDialog(false)}}
        open={openDialog}
      >
        <DialogTitle>
          <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
            Remove Contributor
            <IconButton onClick={() => {setOpenDialog(false)}} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent id="contributorInfo">
          Are you sure you want to remove {name} as a contributor?
        </DialogContent>
        <DialogActions>
          <Button
            id="removeContributorConfirm"
            variant="contained"
            color="primary"
            onClick={handleRemove}
          >
            Remove
          </Button>
          <Button
            id="removeContributorCancel"
            variant="contained"
            color="secondary"
            onClick={() => {setOpenDialog(false)}}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}


const mapStateToProps = state => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  };
};

const mapDispatchToProps = { getMindfile, getCurrentUserMindfiles };

export default connect(mapStateToProps, mapDispatchToProps)(ContributorCard);
